<template>
    <b-sidebar
      id="languages-form-sidebar"
      :visible="isLanguagesFormSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @shown="getData(languagesData)"
      @hidden="resetForm"
      @change="(val) => $emit('update:is-languages-form-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            Group Form
          </h5>
  
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
  
        </div>
  
        <!-- BODY -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
  
            <!-- Full Name -->
            <validation-provider
              #default="validationContext"
              name="Name"
              rules="required"
            >
              <b-form-group
                label="Name"
                label-for="Name"
              >
                <b-form-input
                  id="name"
                  v-model="Data.name"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Name"
               
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="Code"
              rules="required"
            >
              <b-form-group
                label="Code"
                label-for="Code"
              >
                <b-form-input
                  id="code"
                  v-model="Data.code"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Code"
               
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
             #default="validationContext"
             name="is_active"
             rules="min:0"
           >
             <b-form-group
               label="Is Active"
               label-for="is_active"
             >
             
               <b-form-checkbox
               id="is_active"
                               checked="true"
                               class="custom-control-success"
                               v-model="Data.is_active"
                               switch
                 />
 
               <b-form-invalid-feedback>
                 {{ validationContext.errors[0] }}
               </b-form-invalid-feedback>
             </b-form-group>
           </validation-provider>
  
  
          
  
            
          
  
         
          
  
  
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                Submit
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
  
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </template>
  
  <script>
  import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { ref } from '@vue/composition-api'
  import { required, alphaNum, email } from '@validations'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'

  import store from '@/store'
  import { slugify } from '@/@fake-db/utils'


  // Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  export default {
    components: {
      BSidebar,
      BForm,
      BFormGroup,
      BFormInput,
      BFormInvalidFeedback,
      BButton,
      vSelect,
      BFormCheckbox,
      // Form Validation
      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      Ripple,
    },
    model: {
      prop: 'isLanguagesFormSidebarActive',
      event: 'update:is-languages-form-sidebar-active',
    },
    props: {
      isLanguagesFormSidebarActive: {
        type: Boolean,
        required: true,
      },
     
      languagesData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        required,
        alphaNum,
        email

      }
    },
   
    setup(props, { emit }) {
      const toast = useToast();
      const blankData = {
      
        name: '',
        cde: '',
        is_active: true,
     
      }
  
      const Data = ref(JSON.parse(JSON.stringify(blankData)))
      const resetData = () => {
        Data.value = JSON.parse(JSON.stringify(blankData))
      }
      const getData = (data)=>{
        console.log('data', data);
        if(data){ 
          Data.value  = JSON.parse(JSON.stringify(data))
          Data.value.is_active = Data.value.is_active === 1?true:false;
        }
        
      
      }
      
      const onSubmit = () => {
        Data.value.is_active = Data.value.is_active?1:0;
        if(Data.value.id){
          store.dispatch('app-languages/updateData', Data.value)
          .then((response) => {
            if(response.data.success === true){
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'success',
                text: `${response.data.message}`,
                },
              });
            }else{
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Error`,
                icon: 'BellIcon',
                variant: 'danger',
                text: `${response.data.message}`,
                },
              });

            }
            emit('refetch-data')
            emit('update:is-languages-form-sidebar-active', false)
          })

        }else{
          store.dispatch('app-languages/addData', Data.value)
          .then((response) => {
            console.log('response',response);
            if(response.data.success === true){
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'success',
                text: `${response.data.message}`,
                },
              });
            }else{
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                title: `Error`,
                icon: 'BellIcon',
                variant: 'danger',
                text: `${response.data.message}`,
                },
              });

            }
            emit('refetch-data')
            emit('update:is-languages-form-sidebar-active', false)
          })

        }
        
      }
  
      const {
        refFormObserver,
        getValidationState,
        resetForm,
      } = formValidation(resetData)
      const changeTitle  = () => {
        //Data.value.slug =  slugify(Data.value.title )
       }
  
      return {
        Data,
        onSubmit,
  
        refFormObserver,
        getValidationState,
        resetForm,
        getData,
        changeTitle
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  
  #languages-form-sidebar {
    .vs__dropdown-menu {
      max-height: 200px !important;
    }
  }
  </style>
  